<template>
	<Page name="distillation" 
	title="La distillation à économie d'énergie (DEE)"
	implementation="1982"
	highestChimney="60"
	tonnesHandled="1200"
	processingTemperature="350 à 400"
	abstract="<p>Cette unité est la première étape de transformation du pétrole brut à son entrée dans la raffinerie. Le pétrole est chauffé à différentes températures et séparé par distillation en différents produits (GPL, essence, kérosène, gazole, fuel lourd).</p>"
	animation="static/animation/DISTI.json">
	<picture slot="thumbnail">
		<img class="lazy"
		sizes="(max-width: 480px) 100vw, 480px"
		data-srcset="
		img/secteur/DISTI_bqur9k_c_scale_w_350.jpg 350w,
		img/secteur/DISTI_bqur9k_c_scale_w_480.jpg 480w"
		data-src="img/secteur/DISTI_bqur9k_c_scale_w_480.jpg"
		src="static/logo-total.jpg"
		alt="">
	</picture>
</Page>
</template>

<script>
	export default {
		name: 'distillation',
		components: {
			Page: () => import('@/components/Page.vue'),
		},
	}
</script>
